import * as Yup from 'yup'
import i18n from 'core/common/i18n'
import { INVALID_CHARACTERS_REGEX } from 'core/common/utils/validation'

export const AnatelCertificationFormSchema = Yup.object().shape({
  anatel: Yup.string().matches(
    INVALID_CHARACTERS_REGEX,
    i18n.t('product.validations.invalidCharacters')
  ),
})
